<cui-section-headline>Asignaturas</cui-section-headline>
<div *ngFor="let evaluacionTipo of asignaturasByEvaluacionTipo | keys">
    <span>{{ evaluacionTipo }}</span>
    <ul>
        <li *ngFor="let asignatura of asignaturasByEvaluacionTipo[evaluacionTipo]">{{ asignatura }}</li>
    </ul>
</div>
